import React from 'react';
import { Hero } from './components/Hero';
import { TestimonialsTop, TestimonialsMore } from './components/Testimonials';
import { Pain } from './components/Pain';
import { Product } from './components/Product';
import { Bonuses } from './components/Bonuses';
import { Countdown } from './components/Countdown';
import { Pricing } from './components/Pricing';
import { ComparisonAI } from './components/ComparisonAI';
import { Guarantee } from './components/Guarantee';
import { FAQ } from './components/FAQ';
import { CostOfInaction } from './components/CostOfInaction';
import { FinalCTA } from './components/FinalCTA';
import { Footer } from './components/Footer';
import { RecentPurchaseToast } from './components/RecentPurchaseToast';
export function App() {
  return <div className="w-full bg-white font-sans text-slate-900" data-id="element-0" data-mp="2wi5pxq64f1t0">
      <main className="w-full" data-id="element-1" data-mp="28suw6sn6u7od">
        <Hero data-id="element-2" data-mp="28s30zixi6bym" />
        <TestimonialsTop data-id="element-3" data-mp="23vkuoemiy5k6" />
        <Pain data-id="element-4" data-mp="23u9ueosaffxt" />
        <Product data-id="element-5" data-mp="23utcc5hxu4bu" />
        <Bonuses data-id="element-6" data-mp="23t8heerpojdg" />
        <Countdown data-id="element-7" data-mp="3ijxpcqos80jw" />
        <Pricing data-id="element-8" data-mp="3ikh7o8icgqyg" />
        <ComparisonAI data-id="element-9" data-mp="3iiweam7rne26" />
        <TestimonialsMore data-id="element-10" data-mp="3ijfunyhrpue3" />
        <Guarantee data-id="element-11" data-mp="3ii4qvyobommz" />
        <FAQ data-id="element-12" data-mp="3mlat8v8bdto6" />
        <CostOfInaction data-id="element-13" data-mp="3mkrbpfmkt7ao" />
        <FinalCTA data-id="element-14" data-mp="3mjzsl4a6121a" />
      </main>
      <Footer data-id="element-15" data-mp="3mj6jvxrnc2gi" />
      <RecentPurchaseToast data-id="element-16" data-mp="3rcj5s04xxv5k" />
    </div>;
}